module.exports = __webpack_public_path__ + "static/media/personalityPlate.59748532.lottie";